import { call, put, select } from 'redux-saga/effects';

import { goToGroupService, goToBusinessService } from './router';
import request from '../request';
import { groupByIdSelector, nextGroupPositionSelector, pathSelector } from '../../../selectors';
import {
  createGroup,
  deleteGroup,
  fetchGroup,
  handleGroupCreate,
  handleGroupDelete,
  handleGroupUpdate,
  updateGroup,
} from '../../../actions';
import api from '../../../api';
import { createLocalId } from '../../../utils/local-id';

export function* createGroupService(businessId, data) {
  const nextData = {
    ...data,
    position: yield select(nextGroupPositionSelector, businessId),
  };

  const localId = yield call(createLocalId);

  yield put(
    createGroup({
      ...nextData,
      businessId,
      id: localId,
    }),
  );

  let group;
  let groupMemberships;

  try {
    ({
      item: group,
      included: { groupMemberships },
    } = yield call(request, api.createGroup, businessId, nextData));
  } catch (error) {
    yield put(createGroup.failure(localId, error));
    return;
  }

  yield put(createGroup.success(localId, group, groupMemberships));
  yield call(goToGroupService, group.id);
}

export function* createGroupInCurrentBusinessService(data) {
  const { businessId } = yield select(pathSelector);

  yield call(createGroupService, businessId, data);
}

export function* handleGroupCreateService(group) {
  yield put(handleGroupCreate(group));
}

export function* fetchGroupService(id) {
  yield put(fetchGroup(id));

  let group;
  let users;
  let businesses;
  let groupMemberships;
  let labels;
  let customers;
  let addresses;
  let sellitems;
  let sellitemMemberships;
  let sellitemLabels;
  let payments;
  let attachments;
  let products;
  let categories;
  let productCategories;
  let shipments;

  try {
    ({
      item: group,
      included: {
        users,
        businesses,
        groupMemberships,
        labels,
        customers,
        addresses,
        sellitems,
        sellitemMemberships,
        sellitemLabels,
        payments,
        attachments,
        products,
        categories,
        productCategories,
        shipments,
      },
    } = yield call(request, api.getGroup, id, { test: 123 }));
  } catch (error) {
    yield put(fetchGroup.failure(id, error));
    return;
  }

  yield put(
    fetchGroup.success(
      group,
      users,
      businesses,
      groupMemberships,
      labels,
      customers,
      addresses,
      sellitems,
      sellitemMemberships,
      sellitemLabels,
      payments,
      attachments,
      products,
      categories,
      productCategories,
      shipments,
    ),
  );
}

export function* updateGroupService(id, data) {
  yield put(updateGroup(id, data));

  let group;
  try {
    ({ item: group } = yield call(request, api.updateGroup, id, data));
  } catch (error) {
    yield put(updateGroup.failure(id, error));
    return;
  }

  yield put(updateGroup.success(group));
}

export function* handleGroupUpdateService(group) {
  yield put(handleGroupUpdate(group));
}

export function* moveGroupService(id, index) {
  const { businessId } = yield select(groupByIdSelector, id);
  const position = yield select(nextGroupPositionSelector, businessId, index, id);

  yield call(updateGroupService, id, {
    position,
  });
}

export function* deleteGroupService(id) {
  const { groupId, businessId } = yield select(pathSelector);

  if (id === groupId) {
    yield call(goToBusinessService, businessId);
  }

  yield put(deleteGroup(id));

  let group;
  try {
    ({ item: group } = yield call(request, api.deleteGroup, id));
  } catch (error) {
    yield put(deleteGroup.failure(id, error));
    return;
  }

  yield put(deleteGroup.success(group));
}

export function* handleGroupDeleteService(group) {
  const { groupId, businessId } = yield select(pathSelector);

  if (group.id === groupId) {
    yield call(goToBusinessService, businessId);
  }

  yield put(handleGroupDelete(group));
}
